import api from '../../api/index';
import config from '../../../static/config.json'; 

// 通用 Module 
const state = {}
const mutations = {}
const getters = {}
const actions = {
  getUrlQuery({
    rootGetters
  }) { // 获取url中的参数 
    return new Promise((resolve, reject) => {
      const query = router.history.current.query;
      console.log(query);
      resolve(query);
    });
  },
  follow({ rootState }, opt) { // 关注 
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v1/exhibition/follow`, opt, rootState.header)
      .then(({
        data
      }) => {
        console.log(data,'data关注')
        if (data) {
          resolve(data);
        }
      });
    }).catch(err => {
      console.log(err);
    });
  },
  cancelFollow({ rootState }, opt) { // 取消关注
    return new Promise((resolve, reject) => {
      api.delete(`${config.https.api}/api/v1/exhibition/follow`, {data:opt, ...rootState.header}).then(({
        data
      }) => {
        if (data) {
          resolve(data);
        }
      });
    }).catch(err => {
      console.log(err);
    });
  },
}
export default {
  state,
  actions,
  mutations,
  getters,
}
